<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Fulfill All Donor Pledges For {{data.createdByName || data.userInfo.name}}</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Enter milestones achieved and fulfill all donor pleges made for {{data.createdByName || data.userInfo.name}} </div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form modal-p2p-padding ">
    <div class="row justify-content-center">
        <div class="col-12">
            <div class="md-form">
                <input mdbInput 
                [(ngModel)]="milestonesAchived" 
                (ngModelChange)="onMilestonesAchivedChange()"
                (focus)="onInputFocus()" 
                maxlength="128"
                type="number" 
                id="milestonesAchived" 
                class="form-control validate mb-0">
                <label mdbLabel [ngClass]="{'active': milestonesAchived}" class="inputLabel" for="milestonesAchived">Enter Milestones Achived</label>
                @if(milestonesAchivedError) {
                    <span class="form-error m-0 red-text body-2">{{milestonesAchivedErrorText}}</span>
                }
            </div>
        </div>
    </div>
    <div class="row justify-content-start">
        <span class="subtitle-1" style="font-weight: 700 !important;">Review Pending Pledges</span>
    </div>

    @if(filteredPledges.length !== 0){
        <div class="row justify-content-center mb-4">
            <span class="body-2"><b>{{filteredPledges.length}} donor(s)</b> will be charged<b> {{ pledgesAmount | currency:'USD':'symbol-narrow':'1.0-0'}} in total</b> </span>
        </div>
    }
    <div class="row">
        @if(filteredPledges.length !== 0){
            <table class="fulfill-donors-table">
                <thead>
                  <tr>
                    <th class="body-3"style="max-width: 270px;">Donor</th>
                    <!-- <th class="body-3">Payment Info</th> -->
                    <th class="body-3">Plege Per Milestone</th>
                    <th class="body-3">Charge Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let pledge of filteredPledges | paginate : { itemsPerPage: 7, currentPage: p }; let idx = index">
                    <tr>
                        <td class="d-flex align-items-center pl-2" >
                            <div class="d-flex flex-column ml-3">
                              <span [innerHTML]="pledge.donorInfo.name" class="subtitle-2"></span>
                            </div>
                        </td>
                        <td class="pr-2">
                            <span class="body-2">{{pledge.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                        </td>
                        <td class="pr-2">
                            <span class="body-2">{{pledge.amountCharged | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                        </td>
                    </tr>
                  </ng-container>
                </tbody>
            </table>
        }@else{
            <span class="body-2 text-center d-block w-100">No pending pledges</span>
        }

    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a [ngClass]="{'disabled': !isFulfillActive}" class="btn btn-sm modal-success-button waves-effect waves-light" (click)="fulfill()">Fulfill Pledges</a>
</div>